import BaseEntity from '@/entities/BaseEntity';

// Per-block audience-compatibility contract returned by
// POST /audiences/validate-compatibility. Every block carries
// { available, message, message_type, reason_code }: the server decides
// availability and builds the (already localized) message text + severity, so
// the client only renders. disabled_audiences lists the audiences to grey out
// in the picker, each with its own reason. Every block must stay predeclared
// here with a non-throwing default: BaseEntity.updateWith skips keys that are
// not already present, and the empty-state / network-failure paths construct
// this descriptor with no rawData.
const block = () => ({ available: true, message: null, message_type: null, reason_code: null });

export default class AudienceCompatibilityValidation extends BaseEntity {
  advantage_plus = block();
  audience_picker = block();
  age = block();
  gender = block();
  geo = block();
  language = block();
  disabled_audiences = [];

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }

  get blocks() {
    return [ this.advantage_plus, this.audience_picker, this.age, this.gender, this.geo, this.language ];
  }

  get hasError() {
    return this.firstErrorMessage !== null;
  }

  get firstErrorMessage() {
    const errorBlock = this.blocks.find(b => b?.message_type === 'error');
    return errorBlock ? errorBlock.message : null;
  }
}
